import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/diaspora': {
    width: 462,
    height: 512,
    paths: [
      {
        d: 'M226.6 354.7C225.2 354.7 138.6 474.6 137.9 474.6 137.2 474.6 51.3 414.1 51 413.4 50.7 412.6 137.6 287.7 137.6 286 137.6 283.8 8 242 0 238.9-1.3 238.4 31.4 137.1 31.7 136.8 32.3 136.1 176.1 183.8 177.2 183.8 177.6 183.8 178.1 183.2 178.2 182.5 178.6 180.5 179.2 33.9 179.9 32.9 180.7 31.7 284.4 32.2 285 32.6 286.5 33.6 288.5 188.7 291.1 188.7 292.5 188.7 429.8 141.7 430.4 142.4 431.2 143.3 462.3 244.6 461.9 245 461 245.9 321.7 292.1 321.3 293.8 321 295.2 404.1 415.9 403.8 416.7 403.6 417.4 318.3 480.2 317.5 480.2 316.5 480 228.5 354.7 226.6 354.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/diaspora.js
// module id = K8gP
// module chunks = 144